<template>
  <div class="loginContent">
    <div class="logoImgWrapper">
      <img class="logoImg" v-bind:src="logoImg">
    </div>
    <div class="loginContentHeader">
      <span>안녕하세요 폴라이드입니다.</span>
    </div>
    <div class="loginContentBody">
      <login-input-text v-bind="emailInput" v-on:returnText="getEmail" v-on:pressEnterKey="onLogin"></login-input-text>
      <login-input-text v-bind="passwordInput" v-on:returnText="getPassword" v-on:pressEnterKey="onLogin"></login-input-text>
      <router-link class="linkDefault" to="/find-pwd">비밀번호찾기</router-link>
      <div class="loginButtonWrapper">
        <button class="loginBtn" v-on:click="onLogin" v-bind:disabled="setDisable">로그인</button>
        <button class="signUpBtn" v-on:click="$router.push('/sign-up')">회원가입</button>
      </div>
      <div class="signInValidTextWrapper">
        <span v-if="validText.unauthorized">* 존재하지 않는 유저입니다.</span>
        <span v-if="validText.invalidGrant">* 아이디와 비밀번호가 일치하지 않습니다.</span>
        <span v-if="validText.noEmail">* 이메일을 입력해 주세요.</span>
        <span v-if="validText.noPassword">* 비밀번호를 입력해 주세요.</span>
        <span v-if="validText.withdrawUser">* 탈퇴한 유저입니다.</span>
      </div>
    </div>
  </div>
</template>

<script>
import loginInputText from '../../login/elements/loginInputText.vue'
import store from '../../../store'

export default {
  data () {
    return {
      logoImg: require('@/assets/img/logo.png'),
      emailInput: {
        spanText: '이메일주소',
        placeHolder: '이메일을 입력하세요',
        isPassword: false
      },
      passwordInput: {
        spanText: '비밀번호',
        placeHolder: '비밀번호를 입력하세요',
        isPassword: true
      },
      email: '',
      password: '',
      validText: {
        unauthorized: false,
        invalidGrant: false,
        noEmail: false,
        noPassword: false,
        withdrawUser: false
      }
    }
  },
  components: {
    'login-input-text': loginInputText
  },
  methods: {
    validCheck: function () {
      this.validText.unauthorized = false
      this.validText.invalidGrant = false
      this.validText.noEmail = false
      this.validText.noPassword = false
      this.validText.withdrawUser = false
      if(this.email === '' || this.email == null) {
        this.validText.noEmail = true
        return false
      }
      if(this.password === '' || this.password == null) {
        this.validText.noPassword = true
        return false
      }
      return true
    },
    getEmail: function (returnText) {
      this.email = returnText
    },
    getPassword: function (returnText) {
      this.password = returnText
    },
    onLogin: async function () {
      if(this.validCheck() && this.browserCheck()) {
        try {
          await this.$store.dispatch('accessTokenApi', {email: this.email, password: this.password})
          // 회원탈퇴 유저 체크
          let isWithDrawUser = await store.dispatch('checkWithdrawAdUserApi')
          if(!isWithDrawUser) {
            let lastSignUpUserEmail = this.$store.getters.getLastSignUpUserEmail
            if(lastSignUpUserEmail === this.email) {
              // 첫 로그인한 경우
              this.$store.commit('setLastSignUpUserEmail', {lastSignUpUserEmail: null})
              await this.$router.push({name: 'mainBoard', params: {initUser: true}})
            }else {
              this.$store.commit('setLastSignUpUserEmail', {lastSignUpUserEmail: null})
              await this.$router.push({name: 'mainBoard', params: {initUser: false}})
            }
          }else {
            this.validText.withdrawUser = true
          }
        }catch (error) {
          if(error.response.status === 401 && error.response.data.error === 'unauthorized') {
            this.validText.unauthorized = true
          }
          if(error.response.status === 400 && error.response.data.error === 'invalid_grant') {
            this.validText.invalidGrant = true
          }
        }
      }
    },
    browserCheck: function () {
      if(this.$browserDetect.isIE) {
        alert('폴라이드는 인터넷 익스플로러(IE) 브라우저를 지원하지 않습니다. 타 브라우저를 이용해주세요.')
        return false
      }else {
        return true
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if(to.hash !== '' && to.hash.includes('#/')) {
      // s3리다이렉션 기능에 의해 튕겨져 나온 경우
      let goTo = to.hash.replace('#/', '')
      next({path: goTo, replace: true})
    }else {
      // 로컬스토리지 제거
      localStorage.removeItem('vuex')
      next()
    }
  },
  computed: {
    setDisable: function () {
      return (this.email === '' || this.password === '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../assets/css/login.css';
.loginContentHeader{
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  height: 32px;
  font-size: 24px;
  margin-top: 20px;
}

.signInValidTextWrapper {
  text-align: right;
  width: 400px;
  padding-top: 20px;
}

.signInValidTextWrapper > span{
  color: red;
  font-size: 13px;
}

.logoImgWrapper > .logoImg{
  height: 46px;
  width: 185px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/views/singIn.vue